import fp from 'lodash/fp';
import React from 'react';

import { BgIcon, bgShape } from '../../participantIcons';
import { getColorFromString } from './utils';


export type PlaceholderIconProps = {
    name: string;
    isExact?: boolean;
    shape?: bgShape;
    bgColor?: string;
    textColor?: string;
}

export const getTitle = (isExact, name) => isExact ? name : fp.pipe(
    fp.replace(/[-.]/g, ' '),
    fp.replace(
        /([^ a-zA-Zа-яА-Я0-9])|^ОАО|^ООО|^ЗАО|^АО|^ИП|^ПАО|^ГУП|^ОДО|^ФКП/g,
        '',
    ),
    fp.split(' '),
    fp.filter(fp.identity),
    fp.take(2),
    fp.map(str => str.substring(0, 1).toUpperCase()),
    fp.join(''),
)(name);


export const getBgColor = (name: string) => {
    try {
        return getColorFromString(name);
    } catch (err) {
        return '#FF3200';
    }
};

export const PlaceholderIcon = React.memo<PlaceholderIconProps>(
    ({
        name,
        isExact = false,
        shape = 'circle',
        bgColor = getBgColor(name),
        textColor = '#FFF',
    }) => {
        const title = getTitle(isExact, name);
        return (
            <svg viewBox='0 0 24 24'>
                <BgIcon shape={shape} fillColor={bgColor} />
                <text
                    textAnchor='middle'
                    fontSize={`${0.4 / title.length + 0.8}em`}
                    dy='0.36em'
                    x='12'
                    y='12'
                    fill={textColor}
                >
                    {title}
                </text>
            </svg>
        );
    },
);
